import { isDate } from 'lodash';

export const periodRewind = {
  today: 0,
  yesterday: 1,
  last_week: 7,
  last_month: 30
};

export const isEqual = (date1, date2) => {
  const d1 = (date1.constructor === Date ? date1 : Date(date1)) || new Date();
  const d2 = date2.constructor === Date ? date2 : Date(date2) || new Date();
  d1.setMilliseconds(0);
  d2.setMilliseconds(0);
  return d1.getTime() === d2.getTime();
};

export const toFromDate = (date, utc = false) => {
  let d = date;
  if (!isDate(d)) {
    d = new Date(d);
  }
  const args = [d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0];
  return utc ? new Date(Date.UTC(...args)) : new Date(...args);
};

export const toToDate = (date, utc = false) => {
  let d = date;
  if (!isDate(d)) {
    d = new Date(d);
  }
  const args = [d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999];
  return utc ? new Date(Date.UTC(...args)) : new Date(...args);
};

export const getDateRange = (from, to, period, utc = false) => {
  let f = from;
  let t = to;
  if (period !== 'fixed_date' || !f) {
    f = new Date(Date.now());
    f.setDate(f.getDate() - (periodRewind[period] || 0));
  }
  if (!t) {
    t = new Date(Date.now());
  }

  f = toFromDate(f, utc);
  t = toToDate(t, utc);

  return { from: f, to: t };
};

export default { isEqual };



// WEBPACK FOOTER //
// ./app/utils/dateHelpers.js